import { render, staticRenderFns } from "./EventEditDialog.vue?vue&type=template&id=a8da9814&scoped=true"
import script from "./EventEditDialog.vue?vue&type=script&lang=js"
export * from "./EventEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8da9814",
  null
  
)

export default component.exports